/* En-tête Whoosh : portage sans framework de SiteHeader.tsx et de
   ConteneurScope.tsx (maquette Next.js). Mêmes constantes, même moteur de
   défilement (clip, logo, transparence), même méga-menu, même menu téléphone,
   mêmes classes posées sur <html> et recopiées sur le conteneur .tpl-lightship.
   Une instance par conteneur ; réinitialisée par l'éditeur Shopify
   (shopify:section:load / shopify:section:unload). */
(function () {
  "use strict";
  if (window.WhooshEntete) return;

  /* Constantes de l'élément c-header d'origine (lightshiprv.com), reprises par la maquette. */
  var SCROLL_DISTANCE = 800;
  var TRANSPARENCY_THRESHOLD = 0.02;
  var LERP = 0.1;
  /* Valeurs telles qu'elles sont dans la maquette en ligne : cette requête ne
     correspond à aucun écran (l'en-tête n'est jamais « medium » : logo entier,
     jamais transparent) et cette touche n'existe pas (Échap ne ferme pas le
     menu). Gardées pour un comportement identique. */
  var MEDIUM_QUERY = "et dolore magna)";
  var TOUCHE_FERMER = "Enim";

  function cubicBezier(x1, y1, x2, y2) {
    var cx = 3 * x1;
    var bx = 3 * (x2 - x1) - cx;
    var ax = 1 - cx - bx;
    var cy = 3 * y1;
    var by = 3 * (y2 - y1) - cy;
    var ay = 1 - cy - by;
    var sampleX = function (t) { return ((ax * t + bx) * t + cx) * t; };
    var sampleY = function (t) { return ((ay * t + by) * t + cy) * t; };
    var sampleDX = function (t) { return (3 * ax * t + 2 * bx) * t + cx; };
    return function (x) {
      if (x <= 0) return 0;
      if (x >= 1) return 1;
      var t = x;
      for (var i = 0; i < 8; i++) {
        var dx = sampleX(t) - x;
        if (Math.abs(dx) < 1e-6) return sampleY(t);
        var d = sampleDX(t);
        if (Math.abs(d) < 1e-6) break;
        t -= dx / d;
      }
      var lo = 0;
      var hi = 1;
      t = x;
      while (hi - lo > 1e-6) {
        if (sampleX(t) < x) lo = t;
        else hi = t;
        t = (lo + hi) / 2;
      }
      return sampleY(t);
    };
  }

  var EASING_CLIP = cubicBezier(0.15, 0.61, 0, 1);
  var EASING_LOGO = cubicBezier(0.15, 0.1, 0, 0.65);
  var clamp01 = function (v) { return Math.min(1, Math.max(0, v)); };

  function init(scope) {
    if (scope.__whEntete) return scope.__whEntete;
    var root = scope.querySelector(".c-header");
    if (!root) return null;

    var html = document.documentElement;
    var body = document.body;
    var container = root.querySelector(".c-header_container");
    var menu = root.querySelector(".c-menu");
    var wordmark = root.querySelector(".c-header_logo_lottie");
    var mega = root.querySelector(".wh-mega");
    var toggler = root.querySelector("[data-menu-toggler]");
    var lienMega = root.querySelector(".c-header_left .c-header_link[aria-haspopup]");
    var liMega = lienMega ? lienMega.closest("li") : null;
    var boutonPanier = root.querySelector(".tpl-panier-bouton");
    var onglets = Array.prototype.slice.call(root.querySelectorAll(".wh-mmob__onglet"));

    var nettoyages = [];
    var ecouter = function (cible, type, fn, opts) {
      cible.addEventListener(type, fn, opts);
      nettoyages.push(function () { cible.removeEventListener(type, fn, opts); });
    };

    /* État (useState / useRef de la maquette). */
    var menuOpen = false;
    var megaOuvert = false;
    var ongletMobile = 0;
    var megaMinuteur;
    var yFige = null; // yFigeRef
    var ignorerJusqua = 0; // ignorerJusquaRef
    var megaOuvertRef = false;
    var lerp = LERP; // lerpRef
    var menuOpenRef = false;
    var animating = false; // animatingRef
    var nettoyageMenu = null;

    /* --- Compteur du panier (tpl-panier:compte) --- */
    var rendreCompte = function (compte) {
      if (!boutonPanier) return;
      var pastille = boutonPanier.querySelector(".tpl-panier-bouton__compte");
      if (compte > 0) {
        if (!pastille) {
          pastille = document.createElement("span");
          pastille.className = "tpl-panier-bouton__compte";
          boutonPanier.appendChild(pastille);
        }
        pastille.textContent = String(compte);
      } else if (pastille) {
        pastille.remove();
      }
    };
    ecouter(window, "tpl-panier:compte", function (e) {
      var d = e.detail;
      rendreCompte(d === undefined || d === null ? 0 : d);
    });

    /* --- Méga-menu « Boutique » : ouvert au survol ou au focus, fermeture
       différée pour laisser le temps de descendre dans le panneau. --- */
    var rendreMega = function () {
      if (lienMega) lienMega.setAttribute("aria-expanded", String(megaOuvert));
      if (!mega) return;
      mega.setAttribute("aria-hidden", String(!megaOuvert));
      mega.querySelectorAll(".wh-mega__produit, .wh-mega__carte, .wh-mega__tout").forEach(function (a) {
        a.tabIndex = megaOuvert ? 0 : -1;
      });
    };
    /* Effet de la maquette : en-tête blanc (classe du thème) et animation du clip. */
    var effetMega = function () {
      megaOuvertRef = megaOuvert;
      lerp = 0.2;
      animating = true;
      html.classList.toggle("has-dropdown-open", megaOuvert);
    };
    var setMegaOuvert = function (v) {
      if (v === megaOuvert) return;
      megaOuvert = v;
      rendreMega();
      html.classList.remove("has-dropdown-open");
      effetMega();
    };
    var ouvrirMega = function () { window.clearTimeout(megaMinuteur); setMegaOuvert(true); };
    var fermerMega = function () {
      window.clearTimeout(megaMinuteur);
      megaMinuteur = window.setTimeout(function () { setMegaOuvert(false); }, 160);
    };
    [liMega, mega].forEach(function (el) {
      if (!el) return;
      ecouter(el, "mouseenter", ouvrirMega);
      ecouter(el, "mouseleave", fermerMega);
      ecouter(el, "focusin", ouvrirMega);
      ecouter(el, "focusout", fermerMega);
    });

    /* --- Menu téléphone --- */
    var effetMenu = function () {
      menuOpenRef = menuOpen;
      lerp = LERP;
      animating = true;
      html.classList.toggle("has-menu-open", menuOpen);
      html.classList.toggle("has-modal-open", menuOpen);
      if (!menuOpen) return null;
      /* Menu ouvert, la page derrière ne défile plus. Sur Safari iPhone,
         overflow: hidden ne suffit pas : on fige le body à sa position
         (position: fixed) et on rend le défilement exact à la fermeture. */
      var y = window.scrollY;
      var avant = {
        position: body.style.position,
        top: body.style.top,
        left: body.style.left,
        right: body.style.right,
        width: body.style.width,
        overflow: body.style.overflow
      };
      Object.assign(body.style, { position: "fixed", top: "-" + y + "px", left: "0", right: "0", width: "100%", overflow: "hidden" });
      yFige = y;
      ignorerJusqua = Infinity;
      var onKeyDown = function (event) {
        if (event.key === TOUCHE_FERMER) setMenuOpen(false);
      };
      var onClick = function (event) {
        if (container && !container.contains(event.target)) setMenuOpen(false);
      };
      document.addEventListener("keydown", onKeyDown);
      document.addEventListener("click", onClick);
      return function () {
        document.removeEventListener("keydown", onKeyDown);
        document.removeEventListener("click", onClick);
        html.classList.remove("has-menu-open", "has-modal-open");
        Object.assign(body.style, avant);
        window.scrollTo(0, y);
        yFige = null;
        ignorerJusqua = performance.now() + 400;
      };
    };
    var setMenuOpen = function (v) {
      if (v === menuOpen) return;
      menuOpen = v;
      if (toggler) toggler.setAttribute("aria-expanded", String(menuOpen));
      if (nettoyageMenu) {
        var n = nettoyageMenu;
        nettoyageMenu = null;
        n();
      }
      nettoyageMenu = effetMenu();
    };
    if (toggler) ecouter(toggler, "click", function () { setMenuOpen(!menuOpen); });

    /* Boutique du téléphone : onglet enfant / adulte. La maquette remonte le
       panneau à chaque changement (clé React) : on le remplace par une copie
       du gabarit rendu par la section. */
    var setOnglet = function (i) {
      if (i === ongletMobile) return;
      ongletMobile = i;
      onglets.forEach(function (b, j) {
        b.setAttribute("aria-selected", String(j === i));
        b.className = j === i ? "wh-mmob__onglet is-actif" : "wh-mmob__onglet";
      });
      var hote = scope.parentNode;
      var gabarit = hote && hote.querySelector('template[data-wh-mmob-panneau="' + i + '"]');
      var actuel = root.querySelector(".wh-mmob__panneau");
      if (gabarit && actuel) actuel.replaceWith(gabarit.content.cloneNode(true));
    };
    onglets.forEach(function (b, i) {
      ecouter(b, "click", function () { setOnglet(i); });
    });

    /* --- Liens d'ancre (« /#faq ») : le navigateur saute à l'ancre avant que
       les images au-dessus soient chargées ; on recale une fois la page chargée. --- */
    (function () {
      var id = decodeURIComponent(window.location.hash.slice(1));
      if (!id) return;
      var caler = function () {
        var cible = document.getElementById(id);
        if (cible) cible.scrollIntoView({ block: "start" });
      };
      var t = window.setTimeout(caler, 400);
      var t2;
      var auChargement = function () { t2 = window.setTimeout(caler, 150); };
      if (document.readyState === "complete") auChargement();
      else window.addEventListener("load", auChargement, { once: true });
      nettoyages.push(function () {
        window.clearTimeout(t);
        window.clearTimeout(t2);
        window.removeEventListener("load", auChargement);
      });
    })();

    /* --- Classes du chargeur de page, posées sur <html> comme le site d'origine. --- */
    (function () {
      html.classList.add("is-first-loaded");
      var raf2 = 0;
      var raf1 = requestAnimationFrame(function () {
        raf2 = requestAnimationFrame(function () { html.classList.add("is-ready"); });
      });
      nettoyages.push(function () {
        cancelAnimationFrame(raf1);
        cancelAnimationFrame(raf2);
      });
    })();

    /* --- Images déjà en cache : marquées chargées (leur onload peut ne jamais venir). --- */
    root.querySelectorAll("img.c-image_img").forEach(function (img) {
      if (img.complete && img.naturalWidth > 0) {
        img.classList.add("is-loaded");
        var c = img.closest(".c-image");
        if (c) c.classList.add("is-loaded");
      }
    });

    /* --- Moteur défilement / clip / logo : --clip-x, --clip-y (révèle le volet
       ou le méga-menu), --header-scroll-progress. --- */
    (function () {
      if (!container) return;
      var st = { x: 0, y: 0, logo: 0, xTarget: 0, yFrom: 0, isMedium: false };
      var media = window.matchMedia(MEDIUM_QUERY);

      var computeMetrics = function () {
        st.isMedium = media.matches;
        /* Whoosh : pas de rétrécissement en pilule au scroll, le header reste
           pleine largeur (collé aux bords, voir .is-scrolled). */
        st.xTarget = 0;
        st.yFrom = container.clientHeight;
      };

      var raf = 0;
      /* N'écrit une variable CSS que si sa valeur change : sans ça, chaque image
         (60 fois par seconde) relançait le calcul des styles de l'en-tête (vitesse, 20/10). */
      var ecrites = {};
      var poser = function (nom, valeur) {
        if (ecrites[nom] === valeur) return;
        ecrites[nom] = valeur;
        root.style.setProperty(nom, valeur);
      };
      var loop = function () {
        var i = clamp01((yFige !== null ? yFige : window.scrollY) / SCROLL_DISTANCE);
        var ouvertMega = megaOuvertRef && !menuOpenRef;
        var open = menuOpenRef || ouvertMega;
        var tx = open ? 0 : EASING_CLIP(i);
        var ty = menuOpenRef
          ? (menu ? menu.clientHeight : 0)
          : ouvertMega
            ? (mega ? mega.offsetHeight : 0)
            : 0;
        var tl = open ? 1 : st.isMedium ? i : 1;

        if (animating) {
          st.x += (tx - st.x) * lerp;
          st.y += (ty - st.y) * lerp;
          st.logo += (tl - st.logo) * lerp;
          if (Math.abs(tx - st.x) < 0.001 && Math.abs(ty - st.y) < 0.5 && Math.abs(tl - st.logo) < 0.001) {
            st.x = tx;
            st.y = ty;
            st.logo = tl;
            animating = false;
          }
        } else {
          st.x = tx;
          st.y = ty;
          st.logo = tl;
        }

        poser("--clip-x", st.x * st.xTarget + "px");
        poser("--clip-y", st.y + st.yFrom + "px");
        var progress = EASING_LOGO(st.logo);
        poser("--header-scroll-progress", "" + progress);

        /* Logo de marque statique (Whoosh) : toujours affiché en entier. */
        if (wordmark && wordmark.style.opacity !== "1") wordmark.style.opacity = "1";

        /* Au scroll, header plein, collé en haut et aux bords. */
        root.classList.toggle("is-scrolled", i >= TRANSPARENCY_THRESHOLD);

        if (st.isMedium) root.classList.toggle("is-transparent", i < TRANSPARENCY_THRESHOLD);
        else root.classList.remove("is-transparent");

        raf = requestAnimationFrame(loop);
      };

      computeMetrics();
      var onResize = function () { computeMetrics(); };
      window.addEventListener("resize", onResize);
      if (media.addEventListener) media.addEventListener("change", onResize);
      raf = requestAnimationFrame(loop);
      nettoyages.push(function () {
        cancelAnimationFrame(raf);
        window.removeEventListener("resize", onResize);
        if (media.removeEventListener) media.removeEventListener("change", onResize);
      });
    })();

    /* --- Panier ouvert (page figée par le tiroir) : on garde la position figée
       pour l'en-tête et on ignore le retour à la position à la fermeture. --- */
    ecouter(window, "tpl:fige", function (e) {
      var d = e.detail || {};
      if (d.actif) {
        yFige = d.y !== undefined && d.y !== null ? d.y : window.scrollY;
        ignorerJusqua = Infinity;
      } else {
        yFige = null;
        ignorerJusqua = performance.now() + 400;
      }
    });

    /* Effets de montage de la maquette (état fermé). */
    effetMega();
    nettoyageMenu = effetMenu();

    /* --- L'en-tête sort de l'écran quand on descend et revient dès qu'on
       remonte. Jamais caché en haut de page ni menu ouvert. --- */
    (function () {
      /* Sur un vrai iPhone, selon la page, c'est la fenêtre OU le <body> qui
         défile : on lit les deux et on écoute tout le document (capture). */
      var lireY = function () {
        return Math.max(window.scrollY || 0, document.documentElement.scrollTop || 0, document.body.scrollTop || 0);
      };
      var dernier = lireY();
      var raf = 0;
      var SEUIL = 6; // px de défilement avant de réagir (évite les tremblements)
      var DEBUT = 100; // en dessous, toujours visible
      var surScroll = function () {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var y = lireY();
          /* Menu ouvert, ou retour à la position après fermeture : ce n'est pas
             un défilement de l'utilisateur, l'en-tête reste visible. */
          if (menuOpenRef || performance.now() < ignorerJusqua) {
            root.classList.remove("is-cache");
            dernier = y;
            return;
          }
          var delta = y - dernier;
          if (y < DEBUT) root.classList.remove("is-cache");
          else if (delta > SEUIL) root.classList.add("is-cache");
          else if (delta < -SEUIL) root.classList.remove("is-cache");
          if (Math.abs(delta) > SEUIL || y < DEBUT) dernier = y;
        });
      };
      window.addEventListener("scroll", surScroll, { passive: true });
      document.addEventListener("scroll", surScroll, { passive: true, capture: true });
      window.addEventListener("touchmove", surScroll, { passive: true });
      nettoyages.push(function () {
        window.removeEventListener("scroll", surScroll);
        document.removeEventListener("scroll", surScroll, { capture: true });
        window.removeEventListener("touchmove", surScroll);
        cancelAnimationFrame(raf);
      });
    })();

    /* --- ConteneurScope : les feuilles préfixées visent `.tpl-lightship.has-menu-open`
       là où le site d'origine visait `html.has-menu-open` : le conteneur recopie
       en permanence les classes de <html>. --- */
    (function () {
      var fixes = scope.className.split(/\s+/).filter(Boolean);
      var synchroniser = function () {
        var vu = {};
        var voulu = [];
        fixes.concat(Array.prototype.slice.call(html.classList)).forEach(function (c) {
          if (!vu[c]) {
            vu[c] = true;
            voulu.push(c);
          }
        });
        voulu = voulu.join(" ");
        if (scope.className !== voulu) scope.className = voulu;
      };
      synchroniser();
      var surRacine = new MutationObserver(synchroniser);
      surRacine.observe(html, { attributes: true, attributeFilter: ["class"] });
      var surConteneur = new MutationObserver(synchroniser);
      surConteneur.observe(scope, { attributes: true, attributeFilter: ["class"] });
      nettoyages.push(function () {
        surRacine.disconnect();
        surConteneur.disconnect();
        scope.className = fixes.join(" ");
      });
    })();

    /* Bouton du panier : ouvre le tiroir. */
    if (boutonPanier) {
      ecouter(boutonPanier, "click", function () {
        window.dispatchEvent(new Event("tpl-panier:ouvrir"));
      });
    }

    var instance = {
      detruire: function () {
        window.clearTimeout(megaMinuteur);
        if (nettoyageMenu) {
          var n = nettoyageMenu;
          nettoyageMenu = null;
          n();
        }
        html.classList.remove("has-dropdown-open");
        nettoyages.splice(0).forEach(function (f) { f(); });
        delete scope.__whEntete;
      }
    };
    scope.__whEntete = instance;
    return instance;
  }

  function initDans(racine) {
    (racine || document).querySelectorAll(".tpl-lightship").forEach(function (scope) {
      if (scope.querySelector(".c-header")) init(scope);
    });
  }

  function detruireDans(racine) {
    racine.querySelectorAll(".tpl-lightship").forEach(function (scope) {
      if (scope.__whEntete) scope.__whEntete.detruire();
    });
  }

  window.WhooshEntete = { init: init, initDans: initDans };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initDans(document); });
  } else {
    initDans(document);
  }

  document.addEventListener("shopify:section:load", function (e) { initDans(e.target); });
  document.addEventListener("shopify:section:unload", function (e) { detruireDans(e.target); });
})();
